export default "__VITE_ASSET__DBbbUpn$__"